class HeadingStyles {
  "title1a": boolean = true;
  "title1b": boolean = true;

  "heading1a": boolean = true;
  "heading1b": boolean = true;
  "heading2a": boolean = true;
  "heading2b": boolean = true;
  "heading3": boolean = true;
  "heading4a": boolean = true;
  "heading4b": boolean = true;
}

class BodyStyles {
  "variety1": boolean = true;
  "variety2": boolean = true;
  "variety3": boolean = true;
  "variety4": boolean = true;
  "variety5": boolean = true;

  "bodyLarge": boolean = true;
  "body": boolean = true;
  "bodySmall": boolean = true;
  "bodyExtraSmall": boolean = true;

  "scriptLargeA": boolean = true;
  "scriptLargeB": boolean = true;
  "scriptA": boolean = true;
  "scriptB": boolean = true;
}

class LargeStyles extends HeadingStyles {
  "variety1": boolean = true;
  "variety2": boolean = true;

  "bodyLarge": boolean = true;

  "scriptLargeA": boolean = true;
  "scriptLargeB": boolean = true;
  "scriptA": boolean = true;
  "scriptB": boolean = true;
}

class SmallStyles {
  "bodySmall": boolean = true;
  "bodyExtraSmall": boolean = true;

  "variety4": boolean = true;
  "variety5": boolean = true;
}


interface THeadingStyles extends HeadingStyles {}
interface TBodyStyles extends BodyStyles {}
interface TLargeStyles extends LargeStyles {}
interface TSmallStyles extends SmallStyles {}
interface TAllowedTextStyles extends THeadingStyles, TBodyStyles {}

const headingStyles = [...Object.keys(new HeadingStyles())] as (keyof HeadingStyles)[]
const bodyStyles = [...Object.keys(new BodyStyles())] as (keyof BodyStyles)[]
const largeStyles = [...Object.keys(new LargeStyles())] as (keyof LargeStyles)[]
const smallStyles = [...Object.keys(new SmallStyles())] as (keyof SmallStyles)[]


const allowedTextStyles: (keyof TAllowedTextStyles)[] = [
  ...Object.keys(new BodyStyles()) as (keyof BodyStyles)[],
  ...Object.keys(new HeadingStyles()) as (keyof HeadingStyles)[],
]

export { allowedTextStyles, headingStyles, bodyStyles, largeStyles, smallStyles } 

export type { TAllowedTextStyles, THeadingStyles, TBodyStyles, TLargeStyles, TSmallStyles }